import { SignIn } from "modules/auth/Auth"
import { useSearchParams } from "react-router"

export function Login() {
	const [searchParams] = useSearchParams()

	return (
		<SignIn
			routing="hash"
			forceRedirectUrl={searchParams.get("next") || "/check-authorization"}
			appearance={{
				variables: {
					colorPrimary: "var(--color-green-60)",
					colorDanger: "var(--color-red-60)",
					colorSuccess: "var(--color-green-60)",
					colorWarning: "var(--color-yellow-orange-60)",
					colorForeground: "var(--color-navy-100)",
					colorPrimaryForeground: "var(--color-white)",
					colorMutedForeground: "var(--color-navy-80)",
					colorBackground: "var(--color-white)",
					colorRing: "var(--color-mint-60)",
					colorShadow:
						"color-mix(in oklab, var(--color-grey-100) 45%, transparent)",
					colorBorder: "var(--color-navy-100)",
					fontFamily: "var(--font-sans)",
					fontFamilyButtons: "var(--font-sans)",
					fontSize: "var(--text-base)",
					borderRadius: "var(--radius-md)",
				},
				elements: {
					footer: "!hidden",
					formFieldAction: "!text-base",
					headerTitle: "!font-headings !text-xl",
					identityPreviewText: "!font-bold",
					logoImage: "!h-32",
					buttonArrowIcon: "!hidden",
					alternativeMethodsBlockButtonArrow: "!hidden",
				},
			}}
		/>
	)
}
